import { Box, Button, Link, Typography, useMediaQuery } from "@material-ui/core";
/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import styled from "styled-components";
import logo from "Content/shoothillFooterLogo.svg";
import { palette, theme } from "../../Globals/Styles/AppTheme";
import * as sh from "@shoothill/core";
import { Grid } from "@shoothill/core";
import { AppUrls } from "AppUrls";

const Main = styled.div`
    margin-top: auto;
    .MuiTypography-h6 {
        text-transform: none;
    }
    a {
        text-decoration: none;
    }

    h6 {
        font-weight: bold;
        font-size: 0.95rem !important;
    }

    @media (max-width: 767px) {
        svg.logo {
            max-width: 75%;
        }

        .MuiTypography-body1 {
            font-size: 0.75rem;
        }

        h6 {
            font-weight: bold;
            font-size: 0.75rem;
        }
    }
`;

const SocialsGrid = styled(Grid)`
    @media (max-width: 767px) {
        justify-items: center;
    }
`;

// const ExternalLink = styled.a`
//     color: ${palette.secondary.main};
//     font-size: 1em;
// `;

export const Footer: React.FC = () => {
    const isMobile = useMediaQuery("(max-width: 767px)");

    const mainText = (
        <Box textAlign={isMobile ? "center" : "right"} paddingTop={isMobile ? "25px" : "0"} style={{ cursor: "pointer" }}>
            <Button>
                <Link component={RouterLink} to={AppUrls.Client.Home}>
                    <Typography variant={"caption"} color={"textSecondary"}>
                        Home
                    </Typography>
                </Link>
            </Button>
            <Button>
                <Link component={RouterLink} to="/faq">
                    <Typography variant={"caption"} color={"textSecondary"}>
                        How does it work?
                    </Typography>
                </Link>
            </Button>
            <Button>
                <Link component={RouterLink} to="/contact">
                    <Typography variant={"caption"} color={"textSecondary"}>
                        Contact
                    </Typography>
                </Link>
            </Button>
            <Button>
                <Link component={RouterLink} to={AppUrls.Client.Account.Login}>
                    <Typography variant={"caption"} color={"textSecondary"}>
                        Login
                    </Typography>
                </Link>
            </Button>
        </Box>
    );

    const copyright = (
        <Box paddingTop={isMobile ? "10px" : "20px"} textAlign={isMobile ? "center" : undefined}>
            <sh.TypographyX css={""} customcolor="white" variant={isMobile ? "h6" : undefined}>
                <strong>&copy; {new Date().getFullYear()} Shoothill Ltd</strong>
            </sh.TypographyX>
        </Box>
    );

    return (
        <Main>
            <Box
                bgcolor={"#333333"}
                paddingLeft={isMobile ? "10px" : "60px"}
                paddingRight={isMobile ? "10px" : "60px"}
                paddingTop={isMobile ? "10px" : "15px"}
                paddingBottom={isMobile ? "10px" : "15px"}
            >
                <sh.Grid dc={isMobile ? "repeat(auto-fit,minmax(100%,1fr))" : "repeat(auto-fit, minmax(500px,1fr))"} padding={"10px"}>
                    <Box display="flex" flexDirection="rows" alignItems={isMobile ? "center" : "flex-start"}>
                        <img src={logo} alt={"logo"} />
                        <Box>
                            <Box paddingLeft={"25px"}>
                                <SocialsGrid dc={isMobile ? "auto" : "50px 1fr"}>
                                    <Typography display={"inline"} style={{ textAlign: "center", maxWidth: "30px" }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10.472" height="22.453" viewBox="0 0 10.472 22.453">
                                            <path
                                                id="Path_555"
                                                data-name="Path 555"
                                                d="M6.922,6.7V4.881A.95.95,0,0,1,7.9,3.816h2.529V0H6.967A4.38,4.38,0,0,0,2.219,4.7V6.745H0v4.482H2.263V22.453H6.745V11.226h3.328l.133-1.775.266-2.707H6.922Z"
                                                fill="#fff"
                                                fillRule="evenodd"
                                            />
                                        </svg>
                                    </Typography>
                                </SocialsGrid>
                            </Box>
                        </Box>
                        {isMobile && mainText}
                    </Box>
                </sh.Grid>
                <sh.Grid dc={isMobile ? "repeat(auto-fit,minmax(100%,1fr))" : "repeat(auto-fit, minmax(500px,1fr))"} padding={isMobile ? "0px" : "10px"}>
                    {!isMobile && copyright}
                    <Box display={"flex"} justifyContent={isMobile ? "center" : "flex-end"} paddingTop={isMobile ? "0px" : "20px"} fontWeight={700}>
                        <Button onClick={() => window.open(`/terms`, "_blank")}>
                            <Link component={RouterLink} to="/terms" onClick={(e: React.MouseEvent) => e.preventDefault()}>
                                <sh.WhiteText css={""} variant={"h6"} color={"textSecondary"}>
                                    <strong>{"Terms of use"}</strong>
                                </sh.WhiteText>
                            </Link>
                        </Button>
                        <Button onClick={() => window.open(`/privacy`, "_blank")}>
                            <Link component={RouterLink} to="/privacy" onClick={(e: React.MouseEvent) => e.preventDefault()}>
                                <sh.WhiteText css={""} variant={"h6"} color={"textSecondary"}>
                                    <strong>Privacy Policy</strong>
                                </sh.WhiteText>
                            </Link>
                        </Button>
                    </Box>
                    {isMobile && copyright}
                </sh.Grid>
            </Box>
        </Main>
    );
};
